import { useCurrentCitizenPersonaQuery } from "../../../api/features/persona/useCurrentCitizenPersona.query";
import type { IProductSearchGeoContext } from "../../../api/features/product-search/product-search-geo-context.interface";
import { useIsLogged } from "../../../hooks/auth/use-is-logged/use-is-logged";

// bx-main sets registeredRegion to "N/A" when the municipality is unknown
const NOT_AVAILABLE_GEO_VALUE = "N/A";

export function useCitizenGeoContext(enabled: boolean = true): IProductSearchGeoContext | undefined {
  const isLogged = useIsLogged();
  const { persona } = useCurrentCitizenPersonaQuery({ enabled: enabled && isLogged });

  const regionName = persona?.registeredRegion;
  const municipalityCode = persona?.registeredMunicipality;

  const isGeoContextAvailable = !!regionName && !!municipalityCode && regionName !== NOT_AVAILABLE_GEO_VALUE;
  if (!isGeoContextAvailable) {
    return undefined;
  }

  return { regionName, municipalityCode };
}
